"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsOnMedication = void 0;
const native_base_1 = require("native-base");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const organisms_1 = require("../../../organisms");
const AbortFUPModal_1 = require("./AbortFUPModal");
const lodash_1 = __importDefault(require("lodash"));
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const atome_1 = require("../../../atome");
function DetailsOnMedication(props) {
    const { navigation, setCurrentPage, showFUPRModal, setShowFUPRModal } = props;
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const prescriptionInfo = (0, hooks_1.useAppSelector)(reducers_1.selectPrescriptionInfo);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [prescriptionTemp, setPrescriptionTemp] = (0, react_1.useState)(prescriptionInfo);
    const [isButtonDisabled, setIsButtonDisabled] = (0, react_1.useState)(false);
    const lastMedicationPreparations = userInformation?.medication[userInformation?.medication.length - 1]
        .preparationListItem;
    (0, react_1.useEffect)(() => {
        let error = false;
        prescriptionTemp?.preparationQuestion?.forEach((item) => {
            const dailyDosageMaxNoSpaces = item?.dailyDosageMax?.trim();
            const singleDosageMaxNoSpaces = item?.singleDosageMax?.trim();
            const hasEmptyField = dailyDosageMaxNoSpaces?.length === 0 ||
                singleDosageMaxNoSpaces?.length === 0;
            if (hasEmptyField) {
                error = true;
            }
        });
        error ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
    }, [prescriptionTemp]);
    const handleDailyDosageChange = (value, index) => {
        const re = /^[0-9.,]+$/;
        if (value === '' || re.test(value)) {
            const newPrescriptionInfo = lodash_1.default.cloneDeep(prescriptionTemp);
            newPrescriptionInfo.preparationQuestion[index].dailyDosageMax = value;
            setPrescriptionTemp(newPrescriptionInfo);
        }
    };
    const handleSingleDosageMaxChange = (value, index) => {
        const re = /^[0-9.,]+$/;
        if (value === '' || re.test(value)) {
            const newPrescriptionInfo = lodash_1.default.cloneDeep(prescriptionTemp);
            newPrescriptionInfo.preparationQuestion[index].singleDosageMax = value;
            setPrescriptionTemp(newPrescriptionInfo);
        }
    };
    const handleBackButton = () => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 2,
            },
        };
        setCurrentPage(reducerType);
    };
    const next = () => {
        dispatch((0, reducers_1.setPrescriptionInfo)(prescriptionTemp));
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 4,
            },
        };
        setCurrentPage(reducerType);
    };
    // @ts-ignore
    const renderPreparationsItems = preparations => !preparations.length ? (react_1.default.createElement(native_base_1.View, null,
        react_1.default.createElement(native_base_1.Text, null, "Preparation List Items Empty"))) : (preparations.map((item, index) => (react_1.default.createElement(native_base_1.View, { mt: "1", bg: "#f8f8f8", p: "5", key: index },
        react_1.default.createElement(native_base_1.Text, { mt: "3", mb: "3", fontWeight: "bold" }, item.name),
        react_1.default.createElement(native_base_1.Text, null, "Wie viel haben Sie maximal pro Tag von diesem Medikament eingenommen?"),
        react_1.default.createElement(native_base_1.HStack, { alignItems: "center", space: 7, mt: "5" },
            react_1.default.createElement(native_base_1.Input, { w: "80px", h: "110%", bgColor: "#EFEFEE", borderRadius: "3xl", borderWidth: 0, value: prescriptionTemp?.preparationQuestion[index]?.dailyDosageMax, onChangeText: value => handleDailyDosageChange(value, index) }),
            item.dosageUnit === 'ml' && react_1.default.createElement(native_base_1.Text, null, "Milliliter (ml)"),
            item.dosageUnit === 'g' && react_1.default.createElement(native_base_1.Text, null, "Gramm (g)")),
        react_1.default.createElement(native_base_1.Text, { fontWeight: "bold" }),
        react_1.default.createElement(native_base_1.Text, { mt: Breakpoints_1.isDesktop ? '7' : '3' }, "Wie hoch war die maximale Einmaldosis?"),
        react_1.default.createElement(native_base_1.HStack, { alignItems: "center", space: 7, mt: "5", mb: "3" },
            react_1.default.createElement(native_base_1.Input, { w: "80px", h: "110%", bgColor: "#EFEFEE", borderRadius: "3xl", borderWidth: 0, value: prescriptionTemp.preparationQuestion[index].singleDosageMax, onChangeText: value => handleSingleDosageMaxChange(value, index) }),
            item.dosageUnit === 'ml' && react_1.default.createElement(native_base_1.Text, null, "Milliliter (ml)"),
            item.dosageUnit === 'g' && react_1.default.createElement(native_base_1.Text, null, "Gramm (g)"))))));
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(atome_1.BetterScrollView, null,
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(native_base_1.VStack, { space: 5, style: GlobalStyles_1.globalStyles.mobileToWebContainer },
                react_1.default.createElement(native_base_1.Center, { mt: "20" },
                    react_1.default.createElement(native_base_1.Text, { fontSize: "2xl", w: "80%", textAlign: "center", color: "#3db384", fontWeight: "bold" }, "Details zur Medikation")),
                react_1.default.createElement(native_base_1.Center, { mt: "3", mb: "3" },
                    react_1.default.createElement(native_base_1.Text, { w: "90%", textAlign: "center" }, "Nennen Sie im Folgenden die Tagesmaximaldosis und die maximale Einmaldosis seit der letzten Rezepteinl\u00F6sung. Bitte nehmen Sie sich etwas Zeit und \u00FCberlegen Sie in Ruhe!")),
                react_1.default.createElement(native_base_1.View, null, renderPreparationsItems(lastMedicationPreparations)),
                react_1.default.createElement(native_base_1.HStack, { space: 10, mb: "10", justifyContent: 'center' },
                    react_1.default.createElement(native_base_1.Button, { mt: "12", w: ['40%', '10%'], alignSelf: 'center', backgroundColor: '#fff', borderRadius: "3xl", _text: { color: '#3db384', fontWeight: 'bold', underline: true }, onPress: handleBackButton }, "Zur\u00FCck"),
                    react_1.default.createElement(native_base_1.Button, { isDisabled: isButtonDisabled, mt: "12", w: ['40%', '10%'], alignSelf: 'center', backgroundColor: isButtonDisabled ? '#3db38475' : '#3db384', borderRadius: "3xl", _text: { color: '#fff', fontWeight: 'bold' }, onPress: next }, "Weiter"))),
            react_1.default.createElement(AbortFUPModal_1.AbortFUPModal, { navigation: navigation, setCurrentPage: setCurrentPage, showFUPRModal: showFUPRModal, setShowFUPRModal: setShowFUPRModal }))));
}
exports.DetailsOnMedication = DetailsOnMedication;
